export default function () {
	return {
		favorite: 'all',
		progress: 'all',
		search: '',
		selected_areas: {
			value: 'all'
		},
		selected_groups: {
			value:'all'
		},
		selected_tags: {
			value:'all'
		},
		subscription_type: 'all',
		selected_categories: { label: 'all_f', value: 'all' },
	}
}
